import styled from "styled-components"
export const RedSpan = styled.span`
  border-bottom: 2px solid ${({ theme }) => theme.red};
  font-weight: bolder;
`
